import { effect, Injectable, signal } from '@angular/core';
import { Binder, BinderTag } from 'src/app/models/binder.model';
import { BinderService } from '../api/binder.service';

@Injectable({
  providedIn: 'root'
})

export class BinderTagsService {
  currentBinderTag = signal<BinderTag[]>([]);

  constructor(private currentBinderService: BinderService) {
    effect(() => {
      this.processBinder(this.currentBinderService.currentBinder());
    });
   }

  addHigharcTag() {
    this.addTag('Higharc', 'lx lx-higharc', 'info', 'higharc');
  }

  addTag(name: string, icon: string, color: "success" | "secondary" | "info" | "warn" | "danger" | "contrast" | undefined, type: 'projectStatus' | 'exemption' | 'higharc') {
    this.currentBinderTag.update(tags => {
        const tagIndex = tags.findIndex(tag => tag.type === type);
        if (tagIndex !== -1) {
            // Update existing tag
            const updatedTags = [...tags];
            updatedTags[tagIndex] = { name, icon, color, type };
            return updatedTags;
        } else {
            // Add new tag
            return [...tags, { name, icon, color, type }];
        }
    });
  }
  removeTag(type: 'projectStatus' | 'exemption' | 'higharc') {
    this.currentBinderTag.update(tags => tags.filter(tag => tag.type !== type));
  }


  getExemptionStatus(binder:Binder) {
    if (binder.exPending) {
      this.addTag('Pending', 'pi pi-clock', 'secondary', 'exemption');
    } else if (binder.contractEx === true) {
      this.addTag('Exempt', 'pi pi-exclamation-circle', 'success', 'exemption');
    } else {
      this.removeTag('exemption');
    }
  }

processBinder(binder:Binder) {
  const { icon, color, projectStatus } = this.getStatusDetails(binder.ProjectStatus);
  this.addTag(projectStatus, icon, color, 'projectStatus');
  if (binder.haId) {
    this.addHigharcTag();
  } else {
    this.removeTag('higharc');
  }
  this.getExemptionStatus(binder);
}

getStatusDetails(status: number) {
  let icon: string;
  let color: "success" | "secondary" | "info" | "warn" | "danger" | "contrast" | undefined;
  let projectStatus: string;

  if (status <= 4) {
    icon = 'pi pi-info-circle';
    color = 'info';
    projectStatus = 'Estimate';
  } else {
    switch (status) {
      case 5:
        icon = 'pi pi-clock';
        color = 'secondary';
        projectStatus = 'Pending';
        break;
      case 6:
        icon = 'pi pi-check';
        color = 'success';
        projectStatus = 'Approved';
        break;
      case 7:
      case 8:
        icon = 'pi pi-pencil';
        color = 'info';
        projectStatus = status === 7 ? 'Signing' : 'Drafting';
        break;
      case 21:
        icon = 'pi pi-check';
        color = 'success';
        projectStatus = 'Completed';
        break;
      case 23:
        icon = 'pi pi-times';
        color = 'warn';
        projectStatus = 'Inactive';
        break;
      case 22:
        icon = 'pi pi-clock';
        color = 'secondary';
        projectStatus = 'More Info Needed';
        break;
      default:
        icon = 'pi pi-question';
        color = 'secondary';
        projectStatus = 'Unknown';
    }
  }

  return { icon, color, projectStatus };
}

}
